var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerttriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16884_114050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99983 3.74984V5.41651M4.99983 7.08317H5.00399M4.28733 1.60817L0.758159 7.49984C0.685396 7.62585 0.646895 7.76872 0.646488 7.91422C0.64608 8.05973 0.68378 8.20281 0.755837 8.32923C0.827893 8.45564 0.931795 8.56099 1.0572 8.63478C1.18261 8.70857 1.32516 8.74824 1.47066 8.74984H8.52899C8.67449 8.74824 8.81704 8.70857 8.94245 8.63478C9.06786 8.56099 9.17176 8.45564 9.24381 8.32923C9.31587 8.20281 9.35357 8.05973 9.35316 7.91422C9.35276 7.76872 9.31426 7.62585 9.24149 7.49984L5.71233 1.60817C5.63805 1.48572 5.53346 1.38447 5.40866 1.31421C5.28385 1.24394 5.14305 1.20703 4.99983 1.20703C4.8566 1.20703 4.7158 1.24394 4.59099 1.31421C4.46619 1.38447 4.36161 1.48572 4.28733 1.60817Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16884_114050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerttriangle);
export default __webpack_public_path__ + "static/media/Alert triangle.9bfd5b3c7e5cb1d954136f9ddc7bfeda.svg";
export { ForwardRef as ReactComponent };